const isLocalhostUrl = require('is-localhost-url');

export const IS_LOCAL_DEV = isLocalhostUrl(window.location.href);
